module.exports = __webpack_public_path__ + "img/c-thermometer-img7-2.9798c5db.jpg";